





















import Collapsible from './Collapsible.vue';
import {Vue, Component, Prop, Watch} from "vue-property-decorator";
import $ from "jquery";


@Component({
    components: {
        Collapsible,
    }
})
export default class Card extends Vue {
    @Prop()
    public title!: string;

    @Prop({type: Boolean, default: false})
    public openOnInit!: boolean;

    private opened: boolean = false;

    private created() {
        this.opened = this.openOnInit;
    }

    toggle() {
        // @ts-ignore
        this.$refs.body.toggle();
    }
}
